/**
 * Razorpay Checkout Utility
 * Dynamically loads Razorpay checkout.js SDK and opens standard Razorpay checkout modal.
 */

export const loadRazorpayScript = () => {
  return new Promise((resolve) => {
    if (typeof window !== 'undefined' && window.Razorpay) {
      resolve(true);
      return;
    }

    const existingScript = document.querySelector('script[src="https://checkout.razorpay.com/v1/checkout.js"]');
    if (existingScript) {
      existingScript.addEventListener('load', () => resolve(true));
      existingScript.addEventListener('error', () => resolve(false));
      if (window.Razorpay) {
        resolve(true);
      }
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.async = true;
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
};

export const openRazorpayCheckout = async ({
  orderId,
  amount,
  currency = 'INR',
  keyId,
  name = 'AlphaTrading Alerts',
  description = 'Telegram Monthly Subscription (₹1,000 / Month)',
  prefill = {},
  themeColor = '#0088cc',
  onSuccess,
  onDismiss,
  onError,
}) => {
  try {
    const isLoaded = await loadRazorpayScript();
    if (!isLoaded || !window.Razorpay) {
      const err = new Error(
        'Unable to load Razorpay payment SDK. Please verify your internet connection or disable ad-blockers and try again.'
      );
      if (onError) onError(err.message, err);
      throw err;
    }

    const key = keyId || process.env.REACT_APP_RAZORPAY_KEY_ID || 'rzp_test_SlK2Px9npIq4Qo';

    const options = {
      key,
      amount,
      currency,
      name,
      description,
      order_id: orderId,
      prefill: {
        name: prefill.name || '',
        email: prefill.email || '',
        contact: prefill.contact || '',
      },
      theme: {
        color: themeColor || '#0088cc',
      },
      modal: {
        ondismiss: () => {
          if (onDismiss) onDismiss();
        },
      },
      handler: (response) => {
        if (onSuccess) {
          onSuccess({
            razorpayOrderId: response.razorpay_order_id,
            razorpayPaymentId: response.razorpay_payment_id,
            razorpaySignature: response.razorpay_signature,
          });
        }
      },
    };

    const rzp = new window.Razorpay(options);

    rzp.on('payment.failed', (response) => {
      const msg = response?.error?.description || response?.error?.reason || 'Payment processing failed';
      if (onError) onError(msg, response?.error);
    });

    rzp.open();
    return rzp;
  } catch (err) {
    if (onError) onError(err.message, err);
    throw err;
  }
};
